// Zeitgeist: Die Meinung der Bevölkerung zu den Programmthemen wandert zwischen den Wahlen.
// Alles läuft über den Spiel-Zufallsgenerator, damit Mehrspieler-Partien und Wiederholungen identisch bleiben.
import { AX, AXN } from '../content/axes';
import { S, log } from './state';
import { rnd } from './rng';
import { clamp } from './util';
import { axes } from './axes';

/** Wie weit der Zeitgeist die Grundstimmung höchstens verschiebt (Skala −2 … +2). */
export const ZG_MAX = .9;
/** Höchstens so viele Stufen darf eine Partei ihr Programm vor einem Wahlkampf verschieben. */
export const WENDE_MAX = 3;
/** Wahlkampf-Malus pro verschobener Stufe (Glaubwürdigkeit). */
export const WENDE_COST = .5;

/** Krisen verschieben die Stimmung gezielt. */
export const CRISIS_ZG: Record<string, Record<string, number>> = {
  gas: { atom: .35, klima: -.15 },
  bank: { steuern: .25, haushalt: -.15 },
  pandemie: { buergerv: .25, sozial: .15 },
  streik: { mindestlohn: .25, sozial: .1 },
  krieg: { sicherheit: .4, europa: .2 },
  flucht: { migration: -.35, innen: .15 },
  zoll: { europa: .25, buero: .15 },
  blackout: { innen: .3, sicherheit: .15 },
  flut: { klima: .35, haushalt: .15 },
};

const zg = (): Record<string, number> => (S.zg ??= {});

/** Monatliche Drift: kleiner Zufallsschritt, leicht zurück zur Grundstimmung. */
export function zgTick() {
  const z = zg();
  for (const a of axes()) z[a] = clamp((z[a] || 0) + (rnd() - .5) * .22 - (z[a] || 0) * .015, -ZG_MAX, ZG_MAX);
}

/** Stimmungsumschwung durch eine Krise. */
export function zgShock(id: string) {
  const sh = CRISIS_ZG[id]; if (!sh) return;
  const z = zg();
  for (const a in sh) z[a] = clamp((z[a] || 0) + sh[a], -ZG_MAX, ZG_MAX);
  log(`Die Stimmung im Land verschiebt sich: ${Object.keys(sh).map((a) => `${AXN[a]} ${sh[a] > 0 ? 'mehr Zustimmung' : 'mehr Ablehnung'}`).join(', ')}.`);
}

/** Stimmung zum Zeitpunkt der Wahl festhalten, für Trendpfeile im nächsten Wahlkampf. */
export function snapPub(pub: (a: string) => number) {
  S.pubE = Object.fromEntries((axes() as string[]).map((a) => [a, pub(a)]));
}

export type Trend = { d: number; dir: 'zu' | 'weg' | 'stabil' };
/** Verändert sich die Stimmung seit der letzten Wahl zur Position y hin oder davon weg? */
export function trendFor(a: string, y: number, now: number): Trend {
  const then = S.pubE?.[a]; if (then == null) return { d: 0, dir: 'stabil' };
  const d = now - then, gain = Math.abs(y - then) - Math.abs(y - now);
  return { d, dir: Math.abs(d) < .1 || Math.abs(gain) < .05 ? 'stabil' : gain > 0 ? 'zu' : 'weg' };
}
